/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} View_Options_And_ToolsInputs */

const en_view_options_and_tools = /** @type {(inputs: View_Options_And_ToolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View options and tools`)
};

const fr_view_options_and_tools = /** @type {(inputs: View_Options_And_ToolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Options d'affichage et outils`)
};

const de_view_options_and_tools = /** @type {(inputs: View_Options_And_ToolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Optionen und Werkzeuge anzeigen`)
};

const it_view_options_and_tools = /** @type {(inputs: View_Options_And_ToolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visualizza opzioni e strumenti`)
};

const ru_view_options_and_tools = /** @type {(inputs: View_Options_And_ToolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Параметры просмотра и инструменты`)
};

const es_view_options_and_tools = /** @type {(inputs: View_Options_And_ToolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver opciones y herramientas`)
};

const zh_cn2_view_options_and_tools = /** @type {(inputs: View_Options_And_ToolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`查看选项和工具`)
};

const ja_view_options_and_tools = /** @type {(inputs: View_Options_And_ToolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オプションとツールを表示`)
};

const hi_view_options_and_tools = /** @type {(inputs: View_Options_And_ToolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`विकल्प और उपकरण देखें`)
};

const pt_pt2_view_options_and_tools = /** @type {(inputs: View_Options_And_ToolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opções e ferramentas de visualização`)
};

/**
* | output |
* | --- |
* | "View options and tools" |
*
* @param {View_Options_And_ToolsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const view_options_and_tools = /** @type {((inputs?: View_Options_And_ToolsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<View_Options_And_ToolsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_view_options_and_tools(inputs)
	if (locale === "de") return de_view_options_and_tools(inputs)
	if (locale === "it") return it_view_options_and_tools(inputs)
	if (locale === "ru") return ru_view_options_and_tools(inputs)
	if (locale === "es") return es_view_options_and_tools(inputs)
	if (locale === "zh-CN") return zh_cn2_view_options_and_tools(inputs)
	if (locale === "ja") return ja_view_options_and_tools(inputs)
	if (locale === "hi") return hi_view_options_and_tools(inputs)
	if (locale === "pt-PT") return pt_pt2_view_options_and_tools(inputs)
	return en_view_options_and_tools(inputs)
});